import Alpine from "alpinejs";

Alpine.magic("instantsearchConnectors", () => async () => {
    const module = await import("instantsearch.js/es/connectors");
    return module;
});